/**
 * faq.js
 * Accordion toggle for FAQ items
 */

(function () {
  'use strict';

  function initFAQ(section) {
    var items = section.querySelectorAll('.faq-item');

    items.forEach(function (item) {
      var btn    = item.querySelector('.faq-item__question');
      var answer = item.querySelector('.faq-item__answer');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        // Close all other items
        items.forEach(function (other) {
          var otherBtn    = other.querySelector('.faq-item__question');
          var otherAnswer = other.querySelector('.faq-item__answer');
          if (otherBtn && otherAnswer && other !== item) {
            otherBtn.setAttribute('aria-expanded', 'false');
            otherAnswer.style.maxHeight = '0';
          }
        });

        // Toggle current
        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          answer.style.maxHeight = '0';
        } else {
          btn.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.faq-section').forEach(initFAQ);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector('.faq-section');
    if (section) initFAQ(section);
  });

})();